export const LANDING_NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "preview", label: "Preview" },
  { id: "features", label: "Modules" },
  { id: "flow", label: "How it works" },
  { id: "cta", label: "Create account" }
];

export const SHOPIFY_APP_STORE_URL = "https://apps.shopify.com/tpg-eu-withdrawals";
export const GUARANTEE_DEADLINE = new Date("2026-09-27T00:00:00+02:00");
